angular.module("accordionDelegateInfo.components", []).component("accordionDelegateInfo", {
    templateUrl: "ng/components/delegationRequest/accordionDelegateInfo/accordionDelegateInfo.view.html",
    bindings: {
        richiestePostVendita: "=",
        validateComponent: "&"
    },
    controllerAs: "accordionDelegateInfoCtrl",
    controller: function AccordionDelegateInfo(
        $arcService,
        $searchUserService,
        $timeout,
        $modalService,
        $rootScope,
        $typeDomainService,
        Pf,
        $istatService
    ) {
        var self = this;

        self.$onInit = function () {
            self.supportModel = {
                cfDelegato: "",
                searching: false,
                delega: "",
                enableModal: false,
                datiDelCompleti: false
            }

            self.supportModel.delega = self.richiestePostVendita.metadata.delega;
            self.supportModel.datiDelCompleti = self.supportModel.delega.utenteDelegato.isOk;

            self.mapComuni = $rootScope.comuniMap;
            self.mapComuniNsilSoppressi = $rootScope.mapComuniSoppressi;

            searchCotracts();
            checkValidityComponent();
            getStati();
        };

        var getStati = function () {
            $istatService.getNazioni()
                .then(function (response) {
                    self.nationsList = response.domainList;

                    self.nationsList = self.nationsList.filter(
                        function (elem) {
                            return elem.name != "ITALIA";
                        }
                    );
                });
        };

        self.handleChange = function (property, value) {
            switch (property) {

                default:
                    break;
            }
            checkValidityComponent();
        }

        var searchCotracts = function () {
            $arcService
                .getImmContracts()
                .then(function (response) {
                    self.supportModel.contractList = response.listContratti;
                }).catch(function (error) {
                    console.error(error);
                });
        }

        var checkValidityComponent = function () {
            //TODO: in attesa di finire la mappa
            if (self.supportModel.datiDelCompleti) {
                self.validateComponent({
                    validity: true
                });

                self.richiestePostVendita.metadata.delega = self.supportModel.delega;
            } else {
                self.validateComponent({
                    validity: false
                });
            }
        }

        self.searchPF = function (cf) {
            self.supportModel.searching = true;
            var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
            $searchUserService
                .getCustomerFByNsil(cf.toUpperCase())
                .then(function (pf) {
                    if (!pf || !pf.metadata || !pf.metadata.riUserF) {
                        console.log('Ora devi dare la possibilità di censire la nuova persona');
                        self.supportModel.delega.utenteDelegato = Pf.build({
                            cf: cf
                        }).setDefaultPfValues(self.nationsList, comuni);
                        self.supportModel.delega.utenteDelegato
                    } else {
                        self.supportModel.delega.utenteDelegato = Pf.build(pf.metadata.riUserF).setDefaultPfValues(self.nationsList, comuni);
                        self.supportModel.cfDelegato = "";
                    }
                })
                .catch(function (error) {
                    console.log('error', error);
                })
                .finally(function () {
                    self.supportModel.searching = false;
                })
        }

        self.editDelegato = function (delegato) {
            self.supportModel.enableModal = true;
            self.currentAzienda = delegato;
            $timeout(function () {
                jQuery("#footerInstant").css("z-index", "-1");
                jQuery('.financial-leasing__footer').css("z-index", "-1");
                $modalService.openModal('censusDelegatoModal');
            }, 100)
        }

        self.saveUpdatedData = function (delegato) {
            jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
            self.supportModel.delega.utenteDelegato = delegato;

            console.log("DELEGATO ADDED: ", self.supportModel.delega);
            checkValidityComponent();

            jQuery("#footerInstant").css("z-index", "2");
            jQuery('.financial-leasing__footer').css("z-index", "2");
            $modalService.closeModal("censusDelegatoModal");
            self.supportModel.enableModal = false;
        }

        self.removeDelegato = function () {
            self.supportModel.delega.utenteDelegato = {};
        }

        self.undoModal = function () {
            jQuery("#footerInstant").css("z-index", "2");
            jQuery('.financial-leasing__footer').css("z-index", "2");
            $modalService.closeModal('censusDelegatoModal');
            self.supportModel.enableModal = false;
        }

        self.validateModalDel = function (validity) {
            self.supportModel.datiDelCompleti = validity;
        }
    }
});